<template>
  <Header />
  <div class="container">
    <router-view />
  </div>
</template>

<script>
import Header from '@/components/misc/Header.vue'

export default {
  name: 'DefaultLayout',
  components: {
    Header
  }
}
</script>
